import React from "react";
import "../assets/css/Panel.css";
import Navbar from "../components/Navbar";
import Card from "../components/Card";
import Correction from "../assets/images/correction.svg";
import ExamImage from "../assets/images/exam.svg";
import ExamImage2 from "../assets/images/exam-2.svg";
import ReportImage from "../assets/images/report.svg";
import UsersImage from "../assets/images/users.svg";
import InoivceImage from "../assets/images/invoice.svg"
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

function Panel() {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  return (
    <div className="d-flex flex-column h-100">
      <Navbar />
      <div className="cards-container row justify-content-center flex-fill align-items-center">
        {user.role === 0 && (
          <>
            <Card
              Image={ExamImage2}
              name={"آزمون های پیش رو"}
              onClickCard={() => {
                navigate("/FutureExams");
              }}
            />
            <Card
              Image={ExamImage}
              name={"آزمون های قبلی"}
              onClickCard={() => {
                navigate("/PastExams");
              }}
            />
            <Card
              Image={ReportImage}
              name={"کارنامه ها"}
              onClickCard={() => {
                navigate("/Results");
              }}
            />
              <Card
                  Image={ExamImage}
                  name={"فایل ها"}
                  onClickCard={() => {
                      navigate("/Files");
                  }}
              />
          </>
        )}

        {user.role === 1 && (
          <>
            <Card
              Image={ExamImage}
              name={"آزمون ها"}
              onClickCard={() => {
                navigate("/exams");
              }}
            />
            <Card
              Image={UsersImage}
              name={"کاربران"}
              onClickCard={() => {
                navigate("/users");
              }}
            />
            <Card
              Image={ReportImage}
              name={"کارنامه ها"}
              onClickCard={() => {
                navigate("/Products/Reports");
              }}
            />
              <Card
                  Image={InoivceImage}
                  name={"پرداخت ها"}
                  onClickCard={() => {
                      navigate("/Products/Invoices");
                  }}
              />
              <Card
                  Image={ExamImage2}
                  name={"کد تخفیف"}
                  onClickCard={() => {
                      navigate("/Discounts");
                  }}
              />
              <Card
                  Image={ExamImage2}
                  name={"آزمون های پیش رو"}
                  onClickCard={() => {
                      navigate("/FutureExams");
                  }}
              />
              <Card
                  Image={ExamImage}
                  name={"آزمون های قبلی"}
                  onClickCard={() => {
                      navigate("/PastExams");
                  }}
              />
              <Card
                  Image={ExamImage}
                  name={"فایل ها"}
                  onClickCard={() => {
                      navigate("/Bundles");
                  }}
              />
          </>
        )}
      </div>
    </div>
  );
}

export default Panel;
